import { Typography, useTheme } from '@hmsexp/component-library';
import React from 'react';
import { View } from 'react-native';
import TopicItem from './TopicItem';
import { topicStyling } from './style';
import TopicChart from './TopicChart';

const TopicPlot = props => {
  const { topicData, colorRules, onTopicClick, isChartView = false } = props;

  const theme = useTheme();
  const styles = topicStyling(theme);

  const data = [
    {
      title: 'Top Topics',
      data: topicData?.top_topics,
      isPositiveScore: true
    },
    {
      title: 'Bottom Topics',
      data: topicData?.bottom_topics,
      isPositiveScore: false
    }
  ];

  const renderItem = (item, index) => {
    return (
      <View style={[styles.topicItemContainer, index === 0 && styles.topicFirstItemContainer]} key={index}>
        <View style={styles.topicItemHeader}>
          <Typography variant='subtitle1' fontWeightType='bold'>
            {item?.title}
          </Typography>
          <View style={styles.topicTooltipContainer}>
            <Typography fontWeightType='regular' variant='body2' color='primaryContentLow'>
              {item?.subTitle}
            </Typography>
          </View>
        </View>
        <TopicItem
          colorRules={colorRules}
          onTopicClick={onTopicClick}
          title={item?.title}
          isPositiveScore={item?.isPositiveScore}
          data={item?.data}
        />
      </View>
    );
  };

  if (isChartView) {
    return (
      <View>
        <View style={styles.chartContainer}>
          {data?.map((item, index) => (
            <View style={[styles.chartItem, index === 0 && styles.chartFirstItem]}>
              <TopicChart data={item} />
            </View>
          ))}
        </View>
        <View style={styles.chartContainerFooter}>
          <Typography variant='button' fontWeightType='regular'>
            Impact Score
          </Typography>
        </View>
      </View>
    );
  }

  return <View style={styles.container}>{data?.map(renderItem)}</View>;
};
export default TopicPlot;
